import { importScheduleDialogViewState } from "../";
import { mutatorAction } from "satcheljs";

export default mutatorAction("setRechedMaxRetries", function setReachedMaxRetries(reachedMaxRetries: boolean) {
    importScheduleDialogViewState().reachedMaxRetries = reachedMaxRetries;
});